export const ACCESS_REQUEST_PERMISSIONS = {
  create: 'create-object-access-request',
  cancel: 'cancel-own-object-access-request',
  decide: 'decide-object-access-request',
} as const;

export const ACCESS_REQUEST_PAGE_PERMISSIONS = [
  ACCESS_REQUEST_PERMISSIONS.create,
  ACCESS_REQUEST_PERMISSIONS.cancel,
  ACCESS_REQUEST_PERMISSIONS.decide,
] as const;

export function isIncomingAccessRequestsView(
  hasUserPermission: (permission: string) => boolean
): boolean {
  return (
    hasUserPermission(ACCESS_REQUEST_PERMISSIONS.decide) &&
    !hasUserPermission(ACCESS_REQUEST_PERMISSIONS.cancel)
  );
}

export function canViewAccessRequestsSection(
  hasUserPermission: (permission: string) => boolean
): boolean {
  return ACCESS_REQUEST_PAGE_PERMISSIONS.some(hasUserPermission);
}
